"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTokenValidAfter = exports.isValidToken = void 0;
const jwt_decode_1 = __importDefault(require("jwt-decode"));
function isValidToken(token) {
    var _a;
    const decoded = (0, jwt_decode_1.default)(token);
    const exp = (_a = decoded === null || decoded === void 0 ? void 0 : decoded.exp) !== null && _a !== void 0 ? _a : 0;
    const currentTime = Date.now() / 1000;
    return exp > currentTime;
}
exports.isValidToken = isValidToken;
/**
 *
 * @description Check the token validation after a duration time
 * @param token the token to verify
 * @param duration the duration time in second
 * @returns {boolean}
 */
function isTokenValidAfter(token, duration) {
    var _a;
    const decoded = (0, jwt_decode_1.default)(token);
    const exp = (_a = decoded === null || decoded === void 0 ? void 0 : decoded.exp) !== null && _a !== void 0 ? _a : 0;
    const currentTime = Date.now() / 1000;
    return exp > currentTime + duration;
}
exports.isTokenValidAfter = isTokenValidAfter;
//# sourceMappingURL=validateToken.js.map